import { render, staticRenderFns } from "./VLightcaseHolder.vue?vue&type=template&id=44c12e64"
import script from "./VLightcaseHolder.vue?vue&type=script&lang=js"
export * from "./VLightcaseHolder.vue?vue&type=script&lang=js"
import style0 from "./VLightcaseHolder.vue?vue&type=style&index=0&id=44c12e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports